"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleGrid = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const SimpleGrid = (props) => {
    const { left, right, justify = 'space-between', alignItems = 'center' } = props;
    return (react_1.default.createElement(core_1.Grid, { container: true, justify: justify, alignItems: alignItems },
        react_1.default.createElement(core_1.Grid, { item: true }, left),
        react_1.default.createElement(core_1.Grid, { item: true }, right)));
};
exports.SimpleGrid = SimpleGrid;
//# sourceMappingURL=index.js.map